import React, { useState, useMemo } from "react";
import {
  Modal,
  View,
  Text,
  TextInput,
  TouchableOpacity,
  ScrollView,
  StyleSheet,
  Platform,
  Dimensions,
} from "react-native";
import { useTranslation } from "react-i18next";
import SvaraModal from "./SvaraModal";
import {
  BtnSidebarClosePng,
  GameRulesTitle,
  MessagesPng,
} from "../../../assets";
import { useDevice } from "../../../utils/hooks/useDevice";
import RenderHTML from "react-native-render-html";
import { analyticsEvents } from "../../../services/firebase/analytics-events.service";
// import { useDevice } from "../../utils/hooks/useDevice"; // ако ти трябва isMobile

type HelpModalProps = {
  onClose: () => void;
  // по желание: onSubmit, ако искаш родителя да хендълва API request
  onSubmit?: (payload: {
    name: string;
    email: string;
    message: string;
  }) => void;
};

const HelpModal: React.FC<HelpModalProps> = ({ onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<"help" | "contacts">("help");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const { isDesktop } = useDevice();
  analyticsEvents.trackOpenHelp();

  // Calculate content width for RenderHTML on Android
  const contentWidth = useMemo(() => {
    if (isDesktop) return 800;
    const screenWidth = Dimensions.get("window").width;
    // Account for padding and margins (90% width with 16px padding on each side)
    return screenWidth * 0.9 - 32;
  }, [isDesktop]);
  const nameError = useMemo(() => {
    if (!submitted) return "";
    if (!name.trim()) {
      return t("T_SITE_CONTACTS_HELP_ERROR_NAME_REQUIRED");
    }
    return "";
  }, [submitted, name, t]);

  const emailError = useMemo(() => {
    if (!submitted) return "";
    if (!email.trim()) {
      return t("T_SITE_CONTACTS_HELP_ERROR_EMAIL_REQUIRED");
    }
    const pattern =
      /^[a-zA-Z0-9]+([\.\-_]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+([\.\-]?[a-zA-Z0-9]+)*(\.[a-zA-Z0-9]{2,})+$/;
    if (!pattern.test(email)) {
      return t("T_SITE_CONTACTS_HELP_ERROR_EMAIL_PATTERN");
    }
    return "";
  }, [submitted, email, t]);

  const messageError = useMemo(() => {
    if (!submitted) return "";
    const trimmed = message.trim();
    if (!trimmed) {
      return t("T_SITE_CONTACTS_HELP_ERROR_MESSAGE_REQUIRED");
    }
    if (trimmed.length < 10) {
      return t("T_SITE_CONTACTS_HELP_ERROR_MESSAGE_MINLENGTH");
    }
    if (trimmed.length > 1000) {
      return t("T_SITE_CONTACTS_HELP_ERROR_MESSAGE_MINLENGTH");
    }
    return "";
  }, [submitted, message, t]);

  const isValid = !nameError && !emailError && !messageError;

  const handleSend = () => {
    setSubmitted(true);
    if (!isValid) return;

    const payload = {
      name: name.trim(),
      email: email.trim(),
      message: message.trim(),
    };

    if (onSubmit) {
      onSubmit(payload);
    } else {
      console.log("Send help:", payload);
    }
  };

  const close = () => {
    setSubmitted(false);
    onClose();
  };
  const html = t("T_SITE_CONTACTS_HELP_HELP_CONTENT");

  const OuterContainer = Platform.OS === "web" && isDesktop ? View : ScrollView;
  const outerContainerProps =
    Platform.OS === "web" && isDesktop
      ? {
          style: {
            flexGrow: 1,
            paddingHorizontal: isDesktop ? 80 : 20,
            paddingTop: 0,
            paddingBottom: 40,
            maxWidth: isDesktop ? 1000 : 350,
            maxHeight: Platform.OS === "web" ? 600 : 500,
            overflow: "hidden" as const,
          },
        }
      : {
          contentContainerStyle: {
            flexGrow: 1,
            paddingHorizontal: isDesktop ? 80 : 20,
            paddingTop: 0,
            paddingBottom: 40,
            maxWidth: isDesktop ? 1000 : 350,
            maxHeight: 500,
          },
        };

  return (
    <SvaraModal
      visible
      onClose={onClose}
      closeIcon={BtnSidebarClosePng}
      // titleImage={GameRulesTitle}
    >
      <OuterContainer {...outerContainerProps}>
        <View style={styles.content}>
          {/* Title + Tabs */}
          <View style={styles.header}>
            {/* <TouchableOpacity style={styles.closeBtn} onPress={close}>
              <Text style={styles.closeText}>×</Text>
            </TouchableOpacity> */}

            <View style={styles.tabsWrapper}>
              <TouchableOpacity
                style={[styles.tab, activeTab === "help" && styles.tabActive]}
                onPress={() => setActiveTab("help")}
              >
                <Text
                  style={[
                    styles.tabText,
                    activeTab === "help" && styles.tabTextActive,
                  ]}
                >
                  {t("T_SITE_CONTACTS_HELP_HELP")}
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={[
                  styles.tab,
                  activeTab === "contacts" && styles.tabActive,
                ]}
                onPress={() => setActiveTab("contacts")}
              >
                <Text
                  style={[
                    styles.tabText,
                    activeTab === "contacts" && styles.tabTextActive,
                  ]}
                >
                  {t("T_SITE_CONTACTS_HELP_CONTACTS")}
                </Text>
              </TouchableOpacity>
            </View>
          </View>

          {/* Body */}
          <View style={styles.body}>
            <ScrollView
              style={styles.scroll}
              contentContainerStyle={styles.scrollContent}
              keyboardShouldPersistTaps="handled"
              nestedScrollEnabled={Platform.OS === "android"}
              showsVerticalScrollIndicator={true}
            >
              {activeTab === "help" ? (
                <View style={styles.helpTextContainer}>
                  {/*  react-native-render-html */}
                  {/* <Text style={styles.helpText}>
                      {t("T_SITE_CONTACTS_HELP_HELP_CONTENT")}
                    </Text> */}
                  {html ? (
                    <RenderHTML
                      contentWidth={contentWidth}
                      source={{ html }}
                      tagsStyles={{
                        h2: {
                          fontSize: 24,
                          color: "#fff",
                          fontWeight: "bold",
                          marginBottom: 12,
                          textAlign: "center",
                        },
                        p: {
                          fontSize: 16,
                          color: "#fff",
                          textAlign: "left",
                          marginRight: 14,
                          paddingRight: 10,
                        },
                        ul: {
                          marginBottom: 10,
                          listStyleType: "none",
                          paddingLeft: 0,
                          marginLeft: 0,
                        },
                        li: {
                          color: "#fff",
                          fontSize: 16,
                          marginBottom: 6,
                          listStyleType: "none",
                          paddingLeft: 20,
                        },
                      }}
                      baseStyle={{
                        color: "#fff",
                      }}
                    />
                  ) : (
                    <Text style={styles.helpText}>
                      {t("T_SITE_CONTACTS_HELP_HELP_CONTENT")}
                    </Text>
                  )}
                </View>
              ) : (
                <View style={styles.form}>
                  {/* Name */}
                  <View
                    style={[
                      styles.formGroup,
                      submitted && !!nameError && styles.formGroupError,
                    ]}
                  >
                    <TextInput
                      style={styles.input}
                      value={name}
                      onChangeText={setName}
                      placeholder={t("T_SITE_CONTACTS_HELP_NAME")}
                      placeholderTextColor="#888"
                      autoCapitalize="words"
                      autoCorrect={false}
                    />
                    {!!nameError && (
                      <Text style={styles.errorText}>{nameError}</Text>
                    )}
                  </View>

                  {/* Email */}
                  <View
                    style={[
                      styles.formGroup,
                      submitted && !!emailError && styles.formGroupError,
                    ]}
                  >
                    <TextInput
                      style={styles.input}
                      value={email}
                      onChangeText={setEmail}
                      keyboardType="email-address"
                      autoCapitalize="none"
                      autoCorrect={false}
                      placeholder={t("T_SITE_CONTACTS_HELP_EMAIL")}
                      placeholderTextColor="#888"
                    />
                    {!!emailError && (
                      <Text style={styles.errorText}>{emailError}</Text>
                    )}
                  </View>

                  {/* Message */}
                  <View
                    style={[
                      styles.formGroup,
                      submitted && !!messageError && styles.formGroupError,
                    ]}
                  >
                    <TextInput
                      style={[styles.input, styles.textArea]}
                      value={message}
                      onChangeText={(text) =>
                        text.length <= 1000 && setMessage(text)
                      }
                      placeholder={t("T_SITE_CONTACTS_HELP_MESSAGE")}
                      placeholderTextColor="#888"
                      multiline
                      numberOfLines={9}
                    />
                    <View style={styles.messageLength}>
                      <Text style={styles.messageLengthText}>
                        {message?.length || 0}/1000
                      </Text>
                    </View>
                    {!!messageError && (
                      <Text style={styles.errorText}>{messageError}</Text>
                    )}
                  </View>

                  {/* Submit */}
                  <View style={styles.submitWrapper}>
                    <TouchableOpacity
                      style={styles.submitButton}
                      onPress={handleSend}
                      activeOpacity={0.85}
                    >
                      <Text style={styles.submitButtonText}>
                        {t("T_SITE_CONTACTS_HELP_SEND")}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              )}
            </ScrollView>
          </View>
        </View>
      </OuterContainer>
    </SvaraModal>
  );
};

const styles = StyleSheet.create({
  content: {
    width: Platform.OS === "web" ? 520 : "90%",
    maxHeight: Platform.OS === "web" ? 550 : 365,
    // backgroundColor: "#111827",
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingTop: Platform.OS === "web" ? 10 : 0,
    paddingBottom: 12,
  },
  header: {
    marginBottom: 8,
    marginTop: Platform.OS === "web" ? 0 : 0,
  },
  closeBtn: {
    position: "absolute",
    right: -4,
    top: -4,
    zIndex: 10,
    padding: 8,
  },
  closeText: {
    color: "#fff",
    fontSize: 22,
  },
  tabsWrapper: {
    flexDirection: "row",
    justifyContent: "center",
    gap: 16,
    marginTop: Platform.OS === "web" ? 8 : 0,
    marginBottom: 8,
  },
  tab: {
    paddingVertical: 6,
    paddingHorizontal: 16,
    borderRadius: 999,
    backgroundColor: "#1f2937",
  },
  tabActive: {
    backgroundColor: "#2563eb",
  },
  tabText: {
    color: "#9ca3af",
    fontWeight: "500",
    textTransform: "uppercase",
    fontSize: 12,
  },
  tabTextActive: {
    color: "#fff",
  },
  body: {
    flex: 1,
    minHeight: 400,
    minWidth: 250,
    ...(Platform.OS === "web" && {
      maxHeight: 450,
    }),
  },
  scroll: {
    flex: 1,
    ...(Platform.OS === "web" && {
      maxHeight: 450,
    }),
  },
  scrollContent: {
    flexGrow: 1,
  },
  helpTextContainer: {
    paddingVertical: 8,
  },
  helpText: {
    color: "#e5e7eb",
    fontSize: 14,
    lineHeight: 20,
  },
  form: {
    paddingVertical: 8,
  },
  formGroup: {
    marginBottom: 12,
    marginTop: 10,
  },
  formGroupError: {
    // можеш да добавиш borderColor: "red", ако искаш
  },
  input: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#4b5563",
    paddingHorizontal: 10,
    paddingVertical: Platform.OS === "web" ? 8 : 6,
    color: "#f9fafb",
    fontSize: 14,
  },
  textArea: {
    minHeight: 100,
    textAlignVertical: "top",
  },
  errorText: {
    color: "#f97373",
    fontSize: 12,
    marginTop: 4,
  },
  messageLength: {
    position: "absolute",
    right: 8,
    bottom: 6,
  },
  messageLengthText: {
    color: "#9ca3af",
    fontSize: 11,
  },
  submitWrapper: {
    alignItems: "center",
    marginTop: 8,
  },
  submitButton: {
    paddingHorizontal: 24,
    paddingVertical: 10,
    borderRadius: 999,
    backgroundColor: "#2563eb",
  },
  submitButtonText: {
    color: "#fff",
    fontWeight: "600",
    textTransform: "uppercase",
    fontSize: 13,
  },
});

export default HelpModal;
